(function initProductGtagInterceptor() {
  function run() {
    window.gtag = window.gtag || function () {
      (window.gtag.q = window.gtag.q || []).push(arguments);
    };

    var originalGtag = window.gtag;

    window.gtag = function () {
      try {
        var args = Array.from(arguments);

        if (args[0] === 'event' && args[1] === 'add_to_cart') {
          var payload = args[2] || {};
          if (payload.items && Array.isArray(payload.items)) {
            payload.items = payload.items.map(function (item) {
              return Object.assign({}, item, {
                name: item.name.split(item.variant)[0].trim().slice(0, -1).trim()
              });
            });
          }
          payload.timestamp = Date.now();
          args[2] = payload;
        }

        if (args[0] === 'event' && args[1] === 'view_item') {
          var viewPayload = args[2] || {};
          if (viewPayload.items && Array.isArray(viewPayload.items)) {
            viewPayload.items = viewPayload.items.map(function (item) {
              return Object.assign({}, item, {
                name: item.name.split(item.variant)[0].trim().slice(0, -1).trim()
              });
            });
          }
          viewPayload.timestamp = Date.now();
          args[2] = viewPayload;
        }
      } catch (err) {
        console.warn('[gtag interceptor]', err);
      }

      return originalGtag.apply(this, arguments);
    };
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 2000 });
  } else {
    window.addEventListener('load', run, { once: true });
  }
})();
